import React, { useState } from "react";
import { Edit } from "@mui/icons-material";
import { Button, Grid } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";

import PatientHistoryForm from "./PatientHistoryForm";
import usePatientHistoryInformation from "./usePatientHistoryInformation";

import { updatePatientHistoryInformation } from "app/services/transmission/patient";
import { changeProfileField } from "app/store/transmission/slice/transmissionSlice";

import { showErrorToast, showSuccessToast } from "utils/toast";

const PatientHistoryInformation = () => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const { patientId } = useSelector((state) => state.transmission);
  const dispatch = useDispatch();
  const { patientHistoryInformation, handleCancel } =
    usePatientHistoryInformation();

  const handleSubmit = async () => {
    try {
      setIsLoading(true);

      const updatedPatientHistoryData = {
        ...patientHistoryInformation,
        strokeHistory:
          patientHistoryInformation.strokeHistory?.toString()?.trim() || "",
        strokeHistoryStatus:
          patientHistoryInformation.strokeHistoryStatus?.toString() ||
          "unknown",
        anticoag: patientHistoryInformation?.anticoag?.toString()?.trim() || "",
        anticoagStatus:
          patientHistoryInformation.anticoagStatus?.toString() || "",
      };

      const {
        diagnosisHistory,
        patientDiagnosis,
        anticoagUpdatedAt,
        anticoagUpdatedBy,
        ...patientHistoryPayload
      } = updatedPatientHistoryData;

      const response = await updatePatientHistoryInformation(patientId, {
        ...patientHistoryPayload,
        diagnosis: updatedPatientHistoryData.patientDiagnosis || [],
      });

      if (!response.error) {
        setIsEditMode(false);
        dispatch(
          changeProfileField({
            type: "patientOriginalHistoryInformation",
            value: updatedPatientHistoryData,
          })
        );
        showSuccessToast(response?.message);
      }
    } catch (error) {
      showErrorToast(error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditClick = () => {
    setIsEditMode(true);
  };

  return (
    <div className="patient-modal__section">
      <div className="patient-form__row patient-form__info">
        <div className="mb-3">
          <Grid container>
            <Grid item xs={11} style={{ textAlign: "left" }}>
              <div className="patient-form__info--header">Patient History</div>
            </Grid>
            {!isEditMode && (
              <Grid item xs={1} style={{ textAlign: "right" }}>
                <Button
                  variant="text"
                  color="secondary"
                  className="profile-edit-button"
                  onClick={handleEditClick}
                >
                  <Edit className="patient-edit-icon billing-cycle-edit-icon" />
                  Edit
                </Button>
              </Grid>
            )}
          </Grid>

          <PatientHistoryForm
            isLoading={isLoading}
            isEditMode={isEditMode}
            handleCancel={handleCancel}
            setIsEditMode={setIsEditMode}
            handleSubmit={handleSubmit}
          />
        </div>
      </div>
    </div>
  );
};

export default PatientHistoryInformation;
